import {store} from "../store";
import {commonSlice} from "./commonSlice";

const defaultErrorMessage = "An error has occurred";

export const commonStore = {
  // State modifiers
  hideError: () => {
    store.dispatch(commonSlice.actions.errorReducer({isOpen: false, message: defaultErrorMessage, timestamp: null}));
  },
  setError: ({isOpen, message = defaultErrorMessage, debugInfo}: {isOpen: boolean, message?: string, debugInfo?: string[]}) => {
    store.dispatch(commonSlice.actions.errorReducer({isOpen, message, debugInfo, timestamp: Date.now()}));
  },

  // Getters
  getError: () => commonSlice.selectors.errorMessageSelector(store.getState()),
}